export default __webpack_public_path__ + "static/petricollarcollection_23-d204471e8e70d840d94e4e5950009fd6.jpg";